import React, {useState} from 'react';
import {Button, message, Upload} from 'antd';
import {UploadOutlined} from "@ant-design/icons";

const API_URL = process.env.REACT_APP_API_URL

const props = {
    name: 'file',
    action: `${API_URL}/api/upload-pdf`,

    beforeUpload: (file) => {
        const isPDF = file.type === 'application/pdf';
        if (!isPDF) {
            message.error(`${file.name} is not a png file`);
        }
        return isPDF || Upload.LIST_IGNORE;
    },
};

const PdfUploader = () => {
    const [fileList, setFileList] = useState([]);

    const handleChange = (info) => {
        let newFileList = [...info.fileList];
        if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
            message.success(`${info.file.name} file uploaded successfully`);
            newFileList = []
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
        setFileList(newFileList); // Обновить состояние fileList
    };

    return (
        <Upload style={{alignSelf: 'flex-end'}}
                fileList={fileList}
                onChange={handleChange}
                {...props}>
            <Button type="text" icon={<UploadOutlined/>}>Загрузить PDF</Button>
        </Upload>
    )
}

export default PdfUploader;
